import api from '../api';

export const activityService = {
    getActivities: async () => {
        const response = await api.get('/activities');
        return response.data;
    },
    getCourseActivities: async (courseId) => {
        const response = await api.get(`/activities/courses/${courseId}`);
        return response.data;
    },
};
